var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCdr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1932 486",
    width: 1932,
    height: 486,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-cdr") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-264-1511h2480v3508h-2480z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #120e36 } \r\n\t\t.s1 { fill: #56c590 } \r\n\t\t.s2 { fill: #ffffff } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page 1",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Object 6",
    className: "s0",
    d: "m360.6 6.1c130.8 0 236.8 106.1 236.8 236.9 0 130.8-106 236.9-236.8 236.9-130.9 0-236.9-106.1-236.9-236.9 0-130.8 106-236.9 236.9-236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Object 7",
    className: "s1",
    d: "m160.1 104.5c76.5 0 138.5 62 138.5 138.5 0 76.5-62 138.5-138.5 138.5-76.5 0-138.5-62-138.5-138.5 0-76.5 62-138.5 138.5-138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Object 8",
    className: "s2",
    d: "m377.3 320.4h-52.3v-132.9q0-5.8 2.3-10.3 4.1-8.4 26.3-11.4 13.2-1.6 39.6-1.6 26.3 0 42.1 2.7 15.8-2.7 42.1-2.7 26.3 0 39.5 1.6 22.3 3 26.4 11.4 2.2 4.5 2.2 10.3v132.9h-52.2v-129.7q0-8.4-15.9-8.4-9.6 0-13.2 2.2-2.3 1.6-2.3 6.2v129.7h-1-51.2-1.1v-129.7q0-4.6-2.3-6.2-3.6-2.2-13.1-2.2-15.9 0-15.9 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Object 9",
    fillRule: "evenodd",
    className: "s2",
    d: "m92 320.4v-154.8h80.4q15.4 0 25.4 1.2 30.5 3.6 30.5 28.7v97q0 15.1-10.9 21.1-12.3 6.8-45 6.8zm52.2-136.3v117.8h15q10.9 0 14.6-3.6 1.8-2.2 1.8-8v-94.2q0-12-15.9-12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Object 12",
    fillRule: "evenodd",
    className: "s1",
    d: "m813.8 243.1c0 20.5-4.4 41.5-18.7 56.9-14.5 15.7-34.7 20.9-55.4 20.9h-59.2v-158.4h62.4c19.1 0 36.9 5.3 50.4 19.2 15.9 16.4 20.5 39.3 20.5 61.4zm96 44.2h-46l-10.6 33.6h-41.1l57.1-158.4h33.5l60.7 158.4h-42zm111.2-85.7v119.3h-38.6v-119.3h-42.4v-39.1h123.3v39.1zm120.6 85.7h-45.9l-10.7 33.6h-41.1l57.1-158.4h33.6l60.7 158.4h-42zm-422.5-89.9v88.6h20.5c8.8 0 18.8-1.6 25.1-8.4 8.2-8.7 9.5-24.5 9.5-35.8 0-9.4-1-20.7-5.4-29.2-2.9-5.6-7.2-9.6-13.1-12.1-6-2.5-13.4-3.1-19.8-3.1zm177.4 55l-10.9-34-10.8 34zm231.9 0l-10.9-34-10.8 34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Object 13",
    fillRule: "evenodd",
    className: "s0",
    d: "m1217.4 321v-148.6h28.3l33.9 105.1 6.9 22q0.6-2.9 2.9-10.2c1.5-4.7 3-9.3 4.4-13.5l34.3-103.4h25.4v148.6h-18.2v-124.3l-41.5 124.3h-17.1l-41.3-126.4v126.4zm166.1-72.4q0-36.5 18.8-57.6 18.7-21.3 49.6-21.2 31-2 49.6 20.6 18.5 22.7 18.5 56.5 0 33.2-19.8 54.9c-13.1 14.5-29.3 21.7-48.4 21.7q-29.3 0-48.8-22.2-19.5-22.3-19.5-52.7zm19.5 0.4q0 26.2 13.6 42 13.6 15.7 35 15.7 21.9 0 35.4-15.7 13.5-15.8 13.5-44.2c0-17.9-4.5-32.3-13.5-43.4q-13.6-16.6-35-16.6-21.6 0-35.3 15.2-13.7 15.2-13.7 47zm181.6 72v-131.1h-47v-17.5h113.1v17.5h-47.2v131.1zm183-148.6h18.9v87.9q0 30.2-11.9 45.6-13.5 17.6-43.8 17.6-30 0-43.6-16.2-12.8-15.2-12.8-47v-87.9h18.9v90.9q0 21.6 8.8 32.1 8.7 10.5 27 10.5 20.7 0 29.6-9.7 8.9-9.8 8.9-32.9zm47.9 100.8l17.9-1.6c1.1 10.9 5.3 19.3 12.5 25.3q10.8 9 29.5 8.9 15.8 0 25.6-7.2 9.8-7.1 9.8-18c0-6.7-2.4-12-7.2-15.7-6.1-4.7-17.7-8.8-34.7-12.4q-25.5-5.3-37.2-16.2-10.8-10.1-10.8-25.5 0-17.5 13.1-28.8 13.9-12.1 37.1-12.1 24.8 0 39.2 12.1 14.4 12.1 14.4 32.3l-18.1 1.4c-1-9.4-4.2-16.5-9.7-21.1q-8.6-7.3-25-7.3-16.2 0-24.7 6.3-8 5.9-8 16c0 5.8 2 10.4 6 13.6 5 4.2 14.3 7.6 27.9 10.1 20.6 4 35.3 9.8 44.2 17.8q11.7 10.4 11.7 27.9 0 18-14.6 30.9-15.1 13.6-38.1 13.6c-18.8 0-33.6-4.6-44.5-13.7q-16.3-13.7-16.3-36.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCdr);
export default __webpack_public_path__ + "static/media/logo-cdr.daa2c8095a7f02809c249429f6f78b39.svg";
export { ForwardRef as ReactComponent };